'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['ircinput'],
    data: function data() {
        return {
            location: _state2.default.setting('emojiLocation')
        };
    },
    computed: {
        emojis: function emojis() {
            var list = {};
            var available = _state2.default.setting('emojis');
            _lodash2.default.each(available, function (code, ascii) {
                list[code] = ascii;
            });
            return list;
        }
    },
    methods: {
        onImgClick: function onImgClick(event) {
            var url = window.getComputedStyle(event.target, null).getPropertyValue('background-image');

            url = Misc.extractURL(url);
            var code = event.target.dataset.code;
            this.ircinput.addImg(code, url);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["inputtools"]) window._kiwi_exports["components"]["inputtools"] = {};
window._kiwi_exports["components"]["inputtools"]["Emoji"]
window._kiwi_exports.components.inputtools.Emoji = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputtools/Emoji.vue
// module id = U6GM
// module chunks = 1